// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file aiUnitMax/aiUnitMax.proto (package aiUnitMax, syntax proto3)
/* eslint-disable */

import type { JsonObject } from "@bufbuild/protobuf";
import { RPC } from "../runtime";

/**
 * @generated from message aiUnitMax.AiUnitMaxRequest
 */
export type AiUnitMaxRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * IANA timezone name (e.g. "Asia/Colombo"). The daily buckets in the response follow it, so
 * DST transitions inside the range are handled correctly and the days stay right even when no
 * dates are sent. Falls back to the fixed offset carried by start_date when empty.
 *
 * @generated from field: string timezone = 5;
 */
timezone?: string;
/**
 * @generated from field: aiUnitMax.UserContext user_context = 3;
 */
userContext?: UserContext;
/**
 * "daily", "weekly", or "monthly"
 *
 * @generated from field: string granularity = 4;
 */
granularity?: string;
}
;
/**
 * @generated from message aiUnitMax.AiUnitMaxResponse
 */
export type AiUnitMaxResponse = {
/**
 * Map of date (string) to resource AI units (map of resource name to float)
 *
 * @generated from field: map<string, google.protobuf.Struct> data = 1;
 */
data?: { [key: string]: JsonObject };
}
;
/**
 * @generated from message aiUnitMax.AiUnitMaxConsumptionEvent
 */
export type AiUnitMaxConsumptionEvent = {
/**
 * Time Interval
 *
 * @generated from field: string hour = 1;
 */
hour?: string;
/**
 * Resource name
 *
 * @generated from field: string resource = 2;
 */
resource?: string;
/**
 * AI unit count
 *
 * @generated from field: float ai_units = 3;
 */
aiUnits?: number;
}
;
/**
 * @generated from message aiUnitMax.AiUnitMaxStatsRequest
 */
export type AiUnitMaxStatsRequest = {
}
;
/**
 * @generated from message aiUnitMax.AiUnitMaxStatsResponse
 */
export type AiUnitMaxStatsResponse = {
/**
 * Maximum AI unit count
 *
 * @generated from field: float total_max_ai_units = 1;
 */
totalMaxAiUnits?: number;
/**
 * Maximum AI unit count
 *
 * @generated from field: float purchased_ai_units = 2;
 */
purchasedAiUnits?: number;
}
;
/**
 * @generated from message aiUnitMax.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc aiUnitMax.AiUnitMaxService.GetHourlyAiUnitMaxConsumption
 */
export const AiUnitMaxService_GetHourlyAiUnitMaxConsumption = new RPC<AiUnitMaxRequest,AiUnitMaxResponse>("POST", "/getHourlyAiUnitMaxConsumption");
/**
 * @generated from rpc aiUnitMax.AiUnitMaxService.GetAiUnitMaxStats
 */
export const AiUnitMaxService_GetAiUnitMaxStats = new RPC<AiUnitMaxStatsRequest,AiUnitMaxStatsResponse>("GET", "/getAiUnitMaxStats");
